import React from "react";
import booksHomeDesktopIcon from "../../images/booksHomeDesktop.png";

const BookSection=()=>{
    return(
        <div className="book-section">
      <div className="book-section-box book-section-text">
        <h1 className="book-section-heading">
          Brought to you by your favorite veterinary books.
        </h1>
        <div className="book-blue-line"></div>
        <p className="book-section-para">
        All of our content is sourced from the world-renowned Blackwell’s Five-Minute Veterinary Consult Series. These books are written and editted by certified veterinarians.
        </p>
      </div>
      <div className="book-section-box book-section-img">
        <img src={booksHomeDesktopIcon} alt="" />
      </div>
    </div>
    );
}
export default BookSection;